// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2320a826","91":"52ff5a65","819":"f4cd939e","846":"bd31bda9","864":"79f04bc0","979":"ac30ee91"}[chunkId] + ".chunk.js";
};